import { css } from 'linaria';

export const mountingTypeSwiperSlide = css`
  && {
    width: 201px;
    height: 162px;
    margin-right: 24px;
    cursor: pointer;

    @media (--only-desktop) {
      width: 152px;
      height: 120px;
    }

    @media (--only-mobile) {
      width: 120px;
      height: 104px;
      margin-right: 16px;
    }
  }
`;

export const mountingTypeGalleryImage = css`
  width: 201px;
  height: 162px;
  border-radius: var(--rounding-m);
  object-fit: cover;

  @media (--only-desktop) {
    width: 152px;
    height: 120px;
  }

  @media (--only-mobile) {
    width: 120px;
    height: 104px;
  }
`;
